<template>
  <div>
    <users-receive-card v-if="isMobile"/>
    <users-receive-table v-if="!isMobile"/>
  </div>
</template>

<script>
import useCommonMixin from "@/components/commonMixin.js";
import UsersReceiveCard from "./UsersReceiveCard.vue";
import UsersReceiveTable from "./UsersReceiveTable.vue";

export default {
  name: "UsersReceive",
  components: {
    UsersReceiveCard,
    UsersReceiveTable
  },
  setup() {
    const { isMobile } = useCommonMixin();
    return { isMobile };
  }
};
</script>

<style></style>
